import Api from "../config/Axios";

const authConfig = (token, user_id) => ({
  headers: {
    Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
    UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
  },
});

export const getRadiusComplianceHistory = (params, token, user_id) => {
  return Api.get("api/web/radius-compliance/history", {
    params,
    ...authConfig(token, user_id),
  });
};
